import C from '../../../constants';

export const unclaimed_properties = (state = {}, action) => {
    switch (action.type) {
        case C.SET_UNCLAIMED_PROPERTIES:
            return action.payload;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/containers/unclaimed/reducers/unclaimedReducer.js